export default "__VITE_ASSET__B3v4Hv3U__"